var map = {
	"./accessory/accessory_cover.png": "GDsN",
	"./background/background_cover.png": "RJXM",
	"./cloth/cloth_cover.png": "zz/7",
	"./face/face_cover.png": "VPbv",
	"./hair/hair_cover.png": "W0EQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VcZ5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/button ^\.\/.*_cover\.png$
// module id = VcZ5
// module chunks = 0